import { ServiceMeterReadingNotFoundProp } from '../../../../types';
import { CatHeading } from '@blocks-react/components/Heading';
import cx from 'classnames';
import styles from '../../../../VisionLink.module.scss';
export const ServiceMeterReadingNotFound = ({
  notFoundLabel
}: ServiceMeterReadingNotFoundProp) => {
  return (
    <CatHeading variant="body-sm">
      <span className={cx('ps-2 ', styles['c-vision-link-cards-text'])}>
        {notFoundLabel}
      </span>
    </CatHeading>
  );
};
